import { render, staticRenderFns } from "./twoColumnTable.vue?vue&type=template&id=ff5231f2&scoped=true&"
import script from "./twoColumnTable.vue?vue&type=script&lang=js&"
export * from "./twoColumnTable.vue?vue&type=script&lang=js&"
import style0 from "./twoColumnTable.vue?vue&type=style&index=0&id=ff5231f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5231f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
